import Swal from "sweetalert2";

function simpleErrorAlert(text) {
    return Swal.fire({
        icon: 'error',
        title: text,
        confirmButtonColor: "#ac0533",
        confirmButtonText: 'Back'
    })
}

export {
    simpleErrorAlert,
}